import { render, staticRenderFns } from "./CoinStoreConfirmModal.vue?vue&type=template&id=107d336a&scoped=true&"
import script from "./CoinStoreConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreConfirmModal.vue?vue&type=style&index=0&id=107d336a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d336a",
  null
  
)

export default component.exports